import React from 'react';
import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%'
      },
      body: {
        backgroundColor: '#F1F1F4',
        height: '100%',
        width: '100%'
      },
      a: {
        textDecoration: 'none',
        color: '#1c84d1'
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }}
  />
);

export default GlobalStyles;
